
import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { startFacturaXID, startListadoFacturas } from "../../../services";





export const useFacturaXID = (id) => {
    const { data, isLoading } = useQuery({
        queryKey: ['factura-id', id], 
        queryFn: () => startFacturaXID(id),
        enabled: id !== "new",
    });

    return { data, isLoading }
}





export const useFacturasQuery = () => {
    const [page, setPage] = useState(0);
    const [termino, setTermino] = useState('');

    const { data, isLoading } = useQuery({
        queryKey: ['list-facturas', { page, termino }], 
        queryFn: () => startListadoFacturas({ page, termino }),
    });
    

    const chagePage = (num) => {
        setPage(num - 1);
    }

    const chageTermino = (valor) => {
        setPage(0);
        setTermino(valor)
    }

    
    return {
        // Estados
        page,
        termino,
        // Metodos
        chagePage,
        chageTermino,
        data, isLoading,
    }
}
